import { parseToItems } from 'utils/parseToItems';

import useTranslation from 'components/fields/ChemicalMixSelectPanelField/hooks/useTranslation';

import useMixes from 'hooks/useMixes';
import useSelectPanelField from 'hooks/useSelectPanelField';

import type { MixSummary } from './types';

const matchesFilter = (mix: MixSummary, searchTerm?: string): boolean => {
    if (!searchTerm) {
        return true;
    }

    return mix.name.toLowerCase().includes(searchTerm.toLowerCase());
};

const useData = () => {
    const { fetch, isLoading } = useMixes();
    const { NO_MIXES_FOUND } = useTranslation();

    const fetchFn = (args?: { name?: string; pageSize?: number }) =>
        // eslint-disable-next-line require-yield
        (async function* () {
            const mixes = (await fetch({ status: 'ACTIVE' })) ?? [];
            const filtered = mixes.filter(mix => matchesFilter(mix, args?.name));

            return filtered;
        })();

    const resetFn = () => {};

    const { handleAsyncFilter, hasNextPage, items, noItemsText, onNextPage } =
        useSelectPanelField<MixSummary>({
            fetchFn,
            noItemsFoundText: NO_MIXES_FOUND,
            parseFn: parseToItems,
            resetFn
        });

    return {
        handleAsyncFilter,
        hasNextPage,
        isLoading,
        items,
        noItemsText,
        onNextPage
    };
};

export default useData;
